import { forwardRef } from 'react';
import tw, { css, styled } from 'twin.macro';
import 'styled-components/macro';

import { AssignmentPosition } from 'play/support/assignmentPosition';

import { ReactComponent as Handle } from './images/handle.svg';

const ResizeHandleInner = styled.div`
  ${tw`w-[2px] h-full bg-[#58647a]`}
`;

const ResizeHandleContainer = styled.div(({ sidebarPosition = 'right' }: { sidebarPosition: AssignmentPosition }) => [
  tw`absolute z-[8500] h-full top-0 bottom-0 pr-[4px] cursor-ew-resize block`,
  sidebarPosition === 'right' ? tw`left-0` : tw`-right-[4px]`,
  css`
    &:hover ${ResizeHandleInner} {
      ${tw`bg-[#6b7d9e]`}
    }
    &:hover svg {
      ${tw`text-[#6b7d9e]`}
    }
    &:hover svg .dot {
      ${tw`text-white`}
    }
  `,
]);

export const ResizeHandle = forwardRef<HTMLDivElement, { sidebarPosition: AssignmentPosition }>(
  ({ sidebarPosition }, ref) => {
    return (
      <ResizeHandleContainer ref={ref} sidebarPosition={sidebarPosition}>
        <ResizeHandleInner>
          <Handle tw="w-[17px] absolute top-1/2 -translate-y-1/2 -left-[8px] text-[#58647a]" />
        </ResizeHandleInner>
      </ResizeHandleContainer>
    );
  },
);
